import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IButtonProps, TButtonTheme } from '@cian/ui-kit/button/types';
import { useDispatch, useSelector } from 'react-redux';

import { onEntryAutorisationPopupOpen, onEntryPointClick } from './analytics/analytics';
import { useConsultantCianChat } from './hooks/useConsultantCianChat';
import { openAutorisationMotivationPopup as openAutorisationMotivationConsultantCianChat } from '../../slices/consultantCianChat';
import { getGaLabel } from '../../selectors/analytics';
import { getRegionId } from '../../selectors/newbuilding';
import { getUser } from '../../selectors/user';

interface ISendMessageButtonContainerProps {
  ref?: React.RefObject<HTMLButtonElement>;
  ariaLabel?: string;
  size: IButtonProps['size'];
  theme: TButtonTheme;
  beforeIcon?: React.JSX.Element;
  noMarginTop?: boolean;
  placeType?: string;
  tabIndex?: number;
}

export const SendMessageButtonContainer = ({
  ref,
  size,
  theme,
  beforeIcon,
  ariaLabel,
  tabIndex,
}: ISendMessageButtonContainerProps) => {
  const { handleOpenChat } = useConsultantCianChat();
  const regionId = useSelector(getRegionId);
  const customLabel = useSelector(getGaLabel);
  const dispatch = useDispatch();
  const user = useSelector(getUser);
  const isAuthenticated = user?.isAuthenticated;

  const onClick = React.useCallback(() => {
    onEntryPointClick({ regionId });
    if (!isAuthenticated) {
      onEntryAutorisationPopupOpen({ regionId, customPageURL: customLabel });
      dispatch(openAutorisationMotivationConsultantCianChat());
    } else {
      handleOpenChat();
    }
  }, [dispatch, handleOpenChat, isAuthenticated]);

  return (
    <Button
      ref={ref}
      data-testid="ConsultantChatButton"
      theme={theme}
      size={size}
      onClick={onClick}
      fullWidth
      beforeIcon={beforeIcon}
      aria-label={ariaLabel}
      tabIndex={tabIndex}
    />
  );
};
